import React, { useState } from "react";

import { LottieLoading } from "../../../../../../components/graphics/LottieLoading";
import { CustomPage } from "../../../../../../support/CustomLink";
import { FormSection } from "../../../../../../support/FormSection";
import { IOrganizationContact } from "../../../../../../types/types";
import OrganizationInvoices from "./OrganizationInvoices";
import OrganizationPayments from "./OrganizationPayments";

type Props = {
  customerId: string;
  organization: IOrganizationContact;
};
export enum PagesBillingEnum {
  invoices = "invoices",
  payments = "payments",
}
export const OrganizationBilling: React.FC<Props> = ({
  customerId,
  organization,
}) => {
  const [activePageBilling, setActivePageBilling] = useState<PagesBillingEnum>(
    PagesBillingEnum.invoices,
  );
  const [isLoading, setIsLoading] = useState(false);

  const pages = {
    [PagesBillingEnum.invoices]: (
      <OrganizationInvoices
        customerId={customerId}
        organization={organization}
      />
    ),
    [PagesBillingEnum.payments]: (
      <OrganizationPayments
        customerId={customerId}
        organization={organization}
      />
    ),
  };

  return (
    <>
      <div className={"tabs my-8"}>
        <CustomPage
          onClick={() => setActivePageBilling(PagesBillingEnum.invoices)}
          isActive={activePageBilling === PagesBillingEnum.invoices}>
          Invoices
        </CustomPage>
        <CustomPage
          onClick={() => setActivePageBilling(PagesBillingEnum.payments)}
          isActive={activePageBilling === PagesBillingEnum.payments}>
          Payments
        </CustomPage>
      </div>
      <FormSection
        name={
          activePageBilling?.charAt(0).toUpperCase() +
          activePageBilling.slice(1)
        }
        extraCx={"overflow-visible"}>
        {isLoading ? (
          <LottieLoading />
        ) : customerId ? (
          pages[activePageBilling]
        ) : null}
      </FormSection>
    </>
  );
};
